import React from 'react';

const SubscriptionDetailsPageConfig = {
	settings: {
		layout: {
			config: {
				adminPage: true
			}
		}
	},
	routes: [
		{
			path: ['/admin/modify-subscription', '/admin/modify-subscription/subscription-information'],
			exact: true,
			component: React.lazy(() => import('./SubscriptionDetailsPage'))
		}
	]
};

export default SubscriptionDetailsPageConfig;
